// extracted by mini-css-extract-plugin
export var activeFilterButton = "_s2-c";
export var backButton = "_s2-4";
export var backIcon = "_s2-5";
export var chevronShortcut = "_s2-6";
export var container = "_s2-1";
export var editor = "_s2-8";
export var editorWrapper = "_s2-7";
export var prefix = "_s2-2";
export var searchIcon = "_s2-3";
export var suffix = "_s2-9";
export var suffixContent = "_s2-a";
export var suffixText = "_s2-b";
export var wrapper = "_s2-0";